import React, { useRef } from "react";
import Navbar from "../components/common/navbar";
import Hero from "../components/home/hero";
import Services from "../components/home/services";
import Industries from "../components/home/industries";
import Pricing from "../components/home/pricing";
import Clients from "../components/home/clients";
import Footer from "../components/common/footer";
import AudioCall from "../components/home/audio_call";
import Working from "../components/home/working";
import CallCard from "../components/home/cx_call";
import ROIAnalysis from "../components/home/roi-analysis";
import FAQ from "../components/home/faq_noura";
import ContactForm from "../components/home/business_contact";

const Landing = () => {
  const contactRef = useRef(null);
  const faqRef = useRef(null);
  const pricingRef = useRef(null);
  const servicesRef = useRef(null);
  const ROIAnalysisRef = useRef(null);

  const scrollToWithOffset = (ref) => {
    const offset = 80; // Adjust this value based on your navbar height
    const elementPosition =
      ref.current.getBoundingClientRect().top + window.pageYOffset;
    window.scrollTo({
      top: elementPosition - offset,
      behavior: "smooth",
    });
  };

  const scrollToContact = () => scrollToWithOffset(contactRef);
  const scrollToFAQ = () => scrollToWithOffset(faqRef);
  const scrollToPricing = () => scrollToWithOffset(pricingRef);
  const scrollToServices = () => scrollToWithOffset(servicesRef);
  const scrollToCallCard = () => scrollToWithOffset(ROIAnalysisRef);

  return (
    <>
      <Navbar
        scrollToFAQ={scrollToFAQ}
        scrollToPricing={scrollToPricing}
        scrollToServices={scrollToServices}
        scrollToCallCard={scrollToCallCard}
      />
      <Hero scrollToContact={scrollToContact} />
      <AudioCall />
      <Working />
      <Industries />
      <div ref={pricingRef}></div>
      <Pricing />
      <div ref={ROIAnalysisRef}></div>
      <ROIAnalysis />
      <div ref={servicesRef}></div>
      <Services />
      <Clients />

      <CallCard />
      <div ref={faqRef}></div>
      <FAQ />
      <div ref={contactRef}></div>
      <ContactForm />
      <Footer />
    </>
  );
};

export default Landing;
